import { capitalize } from '@mui/material';

import { useTranslate } from '../../../../hooks/useTranslate';
import { AiIcon } from '../../../../icons/AiIcon';
import { CategoryType } from '../../../../services/ContentService/ContentService.types';
import { DestinationOptionType } from '../../../DestinationSearch/DestinationSearch.types';
import { AmeliaOption, FakeButton, Text } from './Amelia.styles';

type Props = {
  query: string;
};

export const Amelia = ({ query }: Props) => {
  const { t } = useTranslate();

  const value: DestinationOptionType = {
    label: query,
    category: 'amelia',
    categoryType: '' as CategoryType,
    popularityScore: 0,
    tooltip: '',
  };

  return (
    <AmeliaOption value={value}>
      <Text mobileSize="md">
        {t('explore.amelia.searchPromptSuggestion', {
          searchText: <strong key="prompt">{capitalize(query)}</strong>,
        })}
      </Text>

      <FakeButton>
        <AiIcon />

        {t('explore.amelia.chatButton')}
      </FakeButton>
    </AmeliaOption>
  );
};
